const translations = {
    applications: 'Applications',
    editBattery: 'Edit Battery',
    linkedEntities: 'Linked Entities'
};

export default translations;
